import { useRouter } from 'next/router'
import React, { useContext } from 'react'
import Context from '../utils/Context'
import { toastMessage } from './toastMessage'

const withDiaperBank =
  (Page: (ssProps: any) => JSX.Element | null) =>
  ({ ...props }) => {
    const isClient = typeof window !== 'undefined'
    const context = useContext(Context)

    // if the user was signed in as an admin but their jwt or access token expired, tell them to sign back in

    if (isClient) {
      const router = useRouter()
      if (context.role !== 'public' && (!context.accessToken || !context.jwtToken)) {
        toastMessage({ title: 'Your session is expired', body: 'Please access your diaper bank from your Hello Bello Account' })
        router.push('/')
        return null
      }
    }

    return <Page {...props}></Page>
  }

export default withDiaperBank
